import { searchExceptionsByTermActionTypes, } from './../actions/types';

import {
  SET_DEVICETYPE,
  SET_IMAGETYPE,
  SET_SEARCHTERM,
  SET_DATE
} from './../actions/index';

const initialState = {
  deviceType: '',
  imageType: '',
  searchTerm: '',
  date: '',
  exceptions: []
};

const acquireTelemetryPage = (state = initialState, action) => {
  switch (action.type) {
    case searchExceptionsByTermActionTypes.success:
      return {
        ...state,
        exceptions: action.response
      };
    case SET_DEVICETYPE:
      return {
        ...state,
        deviceType: action.deviceType
      };
    case SET_IMAGETYPE:
      return {
        ...state,
        imageType: action.imageType
      };
    case SET_SEARCHTERM:
      return {
        ...state,
        searchTerm: action.searchTerm
      };
    case SET_DATE:
      return {
        ...state,
        date: action.date
      };
    default:
      return state;
  }
};

export default acquireTelemetryPage;

const getAcquireTelemetryPage = state => state.acquireTelemetryPage;
export const getExceptionsByTerm = state => getAcquireTelemetryPage(state).exceptions;
export const getAcquireDeviceType = state => getAcquireTelemetryPage(state).deviceType;
export const getAcquireImageType = state => getAcquireTelemetryPage(state).imageType;
export const getAcquireSearchTerm = state => getAcquireTelemetryPage(state).searchTerm;
export const getAcquireDate = state => getAcquireTelemetryPage(state).date;


// WEBPACK FOOTER //
// src/reducers/acquireTelemetryPage.js